import { render, staticRenderFns } from "./DossierField.vue?vue&type=template&id=aca6498c&scoped=true&"
import script from "./DossierField.vue?vue&type=script&setup=true&lang=js&"
export * from "./DossierField.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./DossierField.vue?vue&type=style&index=0&id=aca6498c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca6498c",
  null
  
)

export default component.exports